import { getModel } from "./dbService";

export async function getDataFromCache(apiEndpoint: string,timeInMinutes: number,fetchData: () => Promise<any>){
    try{
        const portalCache = await getModel("portalCaching");
        const cacheData = (await portalCache.find({apiUrl:apiEndpoint})).data;
        if(cacheData.length>0){
            const lastUpdatedTime = new Date(cacheData[0].timestamp as string) as any;
            const currentTime = new Date() as any;

            // Calculate the time difference in milliseconds
            const timeDifferenceMilliseconds = (currentTime - lastUpdatedTime) ;

            // Calculate the time difference in minutes
            const timeDifferenceMinutes = timeDifferenceMilliseconds / (1000 * 60);

            // Check if the time difference is greater than or equal to 10 minutes
            const isExpired = timeDifferenceMinutes >= timeInMinutes;
            if(isExpired) {
                const response = await fetchData();
                if(response.status===200){
                    await portalCache.saveAll([{
                        apiUrl: apiEndpoint,
                        timestamp: new Date().toJSON(),
                        response: JSON.stringify(response)
                    }])
                    return response;
                }else{
                    throw new Error("API responded with status: " + response.status);
                }
                
            }else{
                return JSON.parse(cacheData[0].response);
            }
        }else{
            const response = await fetchData();
            if(response.status===200){
                await portalCache.saveAll([{
                    apiUrl: apiEndpoint,
                    timestamp: new Date().toJSON(),
                    response: JSON.stringify(response)
                }])
                return response;
            }else{
                throw new Error("API responded with status: " + response.status);
            }
        }
    }catch(err){
        // Sentry.captureException(err);
    }
    
}